import { Keys } from '@skylab-shared/ui';
import { isFunction } from '@skylab-shared/utils';
import { v4 as uuid } from 'uuid';
import { $ } from './element';

export interface CommonKeysHandler {
    ctrlEnter?: Function;
    esc?: Function;
}

export class CommonKeys {
    private static eventBound: boolean;
    private static eventName: string = `keyup.${uuid()}`;
    private static target = $(document.body);
    private static handlers: CommonKeysHandler[] = [];
    public constructor() {}

    // returns dispose handler function
    public static add(handler: CommonKeysHandler): (() => void) | undefined {
        if (handler &&
            (isFunction(handler.esc) || isFunction(handler.ctrlEnter)) ) {
            this.handlers.push(handler);
            this.setEvent();
            return () => {
                const idx = this.handlers.indexOf(handler);
                if (idx !== -1) {
                    this.handlers.splice(idx, 1);
                }
                this.setEvent();
            };
        }
        return undefined;
    }

    public static clear(): void {
        this.handlers = [];
        this.setEvent();
    }

    private static setEvent(): void {
        if (this.handlers.length && !this.eventBound) {
            this.bindKeyUp();
        } else if (!this.handlers.length && this.eventBound) {
            this.unBindKeyUp();
        }
    }

    private static unBindKeyUp(): void {
        this.target.off(this.eventName);
        this.eventBound = false;
    }

    private static bindKeyUp(): void {
        this.target.on(this.eventName, this.onKeyUp.bind(this));
        this.eventBound = true;
    }

    private static onKeyUp(e?: Event) {
        if (!e) return;
        const keyboardEvent = e as KeyboardEvent;
        const keyCode = keyboardEvent.keyCode || keyboardEvent.which;
        if (this.handlers.length) {
            switch (keyCode) {
                case Keys.Enter:
                    if (keyboardEvent.ctrlKey) {
                        if (isFunction(this.lastHandler.ctrlEnter)) {
                            this.lastHandler.ctrlEnter();
                        }
                    }
                    break;
                case Keys.Esc:
                    if (isFunction(this.lastHandler.esc)) {
                        $(document.activeElement).blur();
                        this.lastHandler.esc();
                    }
                    break;
            }
        }
    }

    private static get lastHandler(): CommonKeysHandler {
        return this.handlers[this.handlers.length - 1];
    }
}
